export const requestRoute = (vehicleData, map, color, setInfoCallback) => {
  if (!vehicleData || !window.Tmapv2) return Promise.resolve([]);

  const {
    startX,
    startY,
    endX,
    endY,
    truckWidth,
    truckHeight,
    truckWeight,
    truckTotalWeight,
    truckLength,
  } = vehicleData;

  const tmapAppKey = process.env.REACT_APP_TMAP_API_KEY;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    appkey: tmapAppKey,
  };

  const body = new URLSearchParams({
    startX,
    startY,
    endX: endX.toString(),
    endY: endY.toString(),
    truckWidth: truckWidth.toString(),
    truckHeight: truckHeight.toString(),
    truckWeight: truckWeight.toString(),
    truckTotalWeight: truckTotalWeight.toString(),
    truckLength: truckLength.toString(),
    reqCoordType: "WGS84GEO",
    resCoordType: "EPSG3857",
    searchOption: "17",
    angle: "172",
    trafficInfo: "Y",
    truckType: "1",
    totalValue: 1,
  });

  return fetch(
    "https://apis.openapi.sk.com/tmap/truck/routes?version=1&format=json",
    {
      method: "POST",
      headers,
      body,
    }
  )
    .then((res) => res.json())
    .then((data) => {
      const polylines = drawRoute(data, map, color);
      const feature = data.features?.[0];
      if (feature?.properties) {
        setInfoCallback({
          distance: feature.properties.totalDistance,
          time: feature.properties.totalTime,
          polylines: polylines,
        });
      }
      return polylines;
    })
    .catch((err) => console.error("경로 요청 실패:", err));
};

// 경로 그리는 함수
const drawRoute = (data, map, color) => {
  const polylines = [];

  data.features?.forEach((item) => {
    if (item.geometry.type === "LineString") {
      const path = item.geometry.coordinates.map((coord) => {
        // EPSG3857 좌표를 WGS84GEO로 변환
        const pt = new window.Tmapv2.Point(coord[0], coord[1]);
        const conv = window.Tmapv2.Projection.convertEPSG3857ToWGS84GEO(pt);
        return new window.Tmapv2.LatLng(conv._lat, conv._lng);
      });

      // 폴리라인(경로선)을 지도에 추가
      const polyline = new window.Tmapv2.Polyline({
        path,
        strokeColor: color,
        strokeWeight: 6,
        map,
      });

      polylines.push(polyline);
    }
  });

  return polylines;
};
